import React from "react";
import ComingSoon from "components/commingSoon";
import HelpPeopleComponent from "assets/icons/svg/helpPeople";

const Help = () => {
  return <ComingSoon icon={<HelpPeopleComponent />} title={"Help"} />;
};

export default Help;
